import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en_lang from './resources/lang/en.json'
import de_lang from './resources/lang/de.json'

const fallbackLng = ['de']
const availableLanguages = ['de'] // add 'en' to make it available.

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en_lang,
            },
            de: {
                translation: de_lang,
            },
        },
        fallbackLng,
        detection: {
            checkWhitelist: true,
        },
        debug: false,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
